import { useLanguage } from '../i18n'

export function About() {
  const { copy } = useLanguage()

  return (
    <section id="sobre" className="section about" aria-labelledby="about-title">
      <div className="container about-layout">
        <div className="about__mark" aria-hidden="true">
          <img className="about__logo" src="/assets/logos/geniuslead-about.svg" alt="" />
        </div>
        <div className="about__content">
          <span className="section-kicker">{copy.about.kicker}</span>
          <h2 id="about-title">{copy.about.title}</h2>
          {copy.about.paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
          <blockquote>{copy.about.quote}</blockquote>
        </div>
      </div>
    </section>
  )
}
